import Injection = EECore.Injection;
import LoginError from "../entities/login/loginError";

@Injection.injectableClass("UserPreferencesService")
export default class UserPreferencesService {

  @Injection.injectableProperty("UserPreferencesService", EECore.Registrations.HTTP_CLIENT)
  private httpClient: EECore.HttpClient;

  constructor(httpClient: EECore.HttpClient) {
    this.httpClient = httpClient;
  }

  getAccessCode() {
    const url = "/eemwpnp1/public/api/userpreferences/accesscode";
    return this.httpClient.get<string>(url, true);
  }

  setAccessCode(accessCode: string) {
    const url = "/eemwpnp1/public/api/userpreferences/accesscode";
    return this.httpClient.post(url, accessCode, true);
  }

  removeAccessCode() {
    const url = "/eemwpnp1/public/api/userpreferences/accesscode";
    return this.httpClient.delete(url, true);
  }

  getSubscriptionCode() {
    const url = "/eemwpnp1/public/api/userpreferences/subscriptioncode";
    return this.httpClient.get<string>(url, true);
  }

  removeSubscriptionCode() {
    const url = "/eemwpnp1/public/api/userpreferences/subscriptioncode";
    return this.httpClient.delete(url, true);
  }

  getLoginErrorCode() {
    const url = "/eemwpnp1/public/api/userpreferences/loginerror";
    return this.httpClient.get<LoginError>(url, true);
  }
}